import { render, staticRenderFns } from "./Scene18.vue?vue&type=template&id=f5190d30&scoped=true"
import script from "./Scene18.vue?vue&type=script&lang=js"
export * from "./Scene18.vue?vue&type=script&lang=js"
import style0 from "./Scene18.vue?vue&type=style&index=0&id=f5190d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5190d30",
  null
  
)

export default component.exports